import React from 'react'

import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './rpfs.css'

const RPFS = (props) => {
  return (
    <div className="rpfs-container10">
      <Helmet>
        <title>RPFS Product Design Case Study | Vlad Butucariu</title>
        <meta
          name="description"
          content="Product design for RPFS, making decentralized storage, file management, access, and costs clearer for creators and technical users."
        />
        <meta
          property="og:title"
          content="RPFS Product Design Case Study | Vlad Butucariu"
        />
        <meta
          property="og:description"
          content="A clear product experience for decentralized file storage built on Radix and IPFS."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/rpfs" />
        <meta property="og:url" content="https://vladbutucariu.com/rpfs" />
      </Helmet>
      <div className="rpfs-thq-wrapper-elm">
        <TopMenu
          text3="Capabilities"
          rootClassName="top-menuroot-class-name"
        ></TopMenu>
        <div className="rpfs-thq-top-section-elm">
          <div className="rpfs-thq-video-div-elm">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="rpfs-video"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="rpfs-thq-video-mobile-elm"
            ></video>
          </div>
          <div className="rpfs-thq-section-elm1">
            <div className="rpfs-thq-color-wrapper-elm1 project-page-shell">
              <div className="rpfs-container11 project-page-intro">
                <div className="rpfs-container12">
                  <div className="rpfs-container13">
                    <img
                      alt="image"
                      src="/Images/tickerpurple.200.svg"
                      className="rpfs-image10"
                    />
                    <div className="rpfs-thq-title-elm">
                      <h1 className="rpfs-text10 header-project">
                        RPFS – DATA STORAGE
                      </h1>
                    </div>
                    <div className="rpfs-thq-subtitle-elm">
                      <div className="rpfs-thq-description-elm1">
                        <h2 className="rpfs-thq-heading-elm">
                          <span>
                            RPFS is a decentralized storage application built on
                            Radix and IPFS. My role covered product experience
                            and interface design, with a focus on making file
                            management, metadata, access, and costs predictable
                            for creators and technical users.
                          </span>
                          <br></br>
                        </h2>
                      </div>
                      <div className="rpfs-thq-tags-elm">
                        <label className="tag-label-big rpfs-text13">
                          product design
                        </label>
                        <label className="rpfs-text14 tag-label-big">
                          dapp
                        </label>
                        <label className="tag-label-big rpfs-text15">
                          webpage
                        </label>
                        <a
                          href="https://rpfs.io"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="rpfs-link"
                        >
                          <label className="rpfs-text16 tag-label-big">
                            https://rpfs.io
                          </label>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rpfs-thq-description-elm2">
                  <div className="rpfs-container14">
                    <span className="rpfs-text17">context</span>
                    <span className="rpfs-text18">
                      The decentralized storage market is crowded, so the
                      challenge was to differentiate RPFS both in features and
                      user communication. A key use case was enabling creators
                      to upload and manage large volumes of NFT-related assets
                      efficiently, with easy access to metadata and links for
                      integration across multiple platforms.
                    </span>
                  </div>
                  <div className="rpfs-container15">
                    <span className="rpfs-text19">Design</span>
                    <span className="rpfs-text20">
                      From the outset, I collaborated closely with developers
                      and engaged with potential users to identify pain points
                      common to competing platforms. Two primary challenges
                      emerged: rising bandwidth costs and the absence of a fully
                      Web3 authentication system. To address cost concerns, we
                      combined multiple technology stacks to minimize
                      traffic-related expenses, ensuring predictable costs for
                      creators even as their NFTs received increasing access
                      across marketplaces and wallets. For authentication, we
                      leveraged the Radix DLT stack to create unique NFT-based
                      login badges. These badges provide enhanced privacy
                      compared to traditional email logins, align with Web3
                      principles, and can be transferred or sold to other users.
                      The design process focused on simplifying file management,
                      improving onboarding, and making complex decentralized
                      storage understandable for users. Wireframes, user flows,
                      and iterative prototypes guided the team in crafting a
                      product that balances functionality, transparency, and
                      usability.
                    </span>
                  </div>
                  <div className="rpfs-container16">
                    <span className="rpfs-text21">Results</span>
                    <span className="rpfs-text22">
                      The resulting experience emphasized clear costs,
                      predictable file management, and familiar navigation. The
                      product interface and landing page explained the service
                      consistently, helping users understand both its everyday
                      utility and its decentralized infrastructure.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rpfs-thq-section-elm2">
          <div className="rpfs-thq-label-elm">
            <span className="rpfs-text25">Loopers</span>
            <span className="rpfs-text26">animation, nft, collection, art</span>
          </div>
          <div className="rpfs-container20">
            <div className="rpfs-thq-item-elm10">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="rpfs-image11"
              />
            </div>
            <div className="rpfs-thq-item-elm11">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="rpfs-image12"
              />
            </div>
            <div className="rpfs-thq-item-elm12">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="rpfs-image13"
              />
            </div>
            <div className="rpfs-thq-item-elm13">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="rpfs-image14"
              />
            </div>
            <div className="rpfs-thq-item-elm14">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="rpfs-image15"
              />
            </div>
            <div className="rpfs-thq-item-elm15">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="rpfs-image16"
              />
            </div>
            <div className="rpfs-thq-item-elm16">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="rpfs-image17"
              />
            </div>
            <div className="rpfs-thq-item-elm17">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="rpfs-image18"
              />
            </div>
            <div className="rpfs-thq-item-elm18">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="rpfs-image19"
              />
            </div>
            <div className="rpfs-thq-item-elm19">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="rpfs-image20"
              />
            </div>
            <div className="rpfs-thq-item-elm20">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="rpfs-image21"
              />
            </div>
            <div className="rpfs-thq-item-elm21">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="rpfs-image22"
              />
            </div>
            <div className="rpfs-thq-item-elm22">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="rpfs-image23"
              />
            </div>
            <div className="rpfs-thq-item-elm23">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="rpfs-image24"
              />
            </div>
            <div className="rpfs-thq-item-elm24">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="rpfs-image25"
              />
            </div>
            <div className="rpfs-thq-item-elm25">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="rpfs-image26"
              />
            </div>
            <div className="rpfs-thq-item-elm26">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="rpfs-image27"
              />
            </div>
            <div className="rpfs-thq-item-elm27">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="rpfs-image28"
              />
            </div>
          </div>
        </div>
        <div className="rpfs-thq-section-elm3">
          <div className="rpfs-thq-color-wrapper-elm2">
            <div className="rpfs-container21">
              <div className="rpfs-thq-pic-elm1">
                <img
                  alt="image"
                  src="/Projects/Web/rpfs%20w11.png"
                  className="rpfs-image29"
                />
                <div className="rpfs-container22">
                  <div className="rpfs-container23">
                    <img
                      alt="image"
                      src="/Projects/Web/rpfs%20w21.png"
                      className="rpfs-image30"
                    />
                  </div>
                  <div className="rpfs-container24">
                    <img
                      alt="image"
                      src="/Projects/Web/rpfs%20w41.png"
                      className="rpfs-image31"
                    />
                  </div>
                </div>
                <div className="rpfs-container25">
                  <img
                    alt="image"
                    src="/Projects/Web/rpfs%20w3.png"
                    className="rpfs-image32"
                  />
                  <div className="rpfs-thq-description-elm3">
                    <p className="rpfs-text27">
                      RPFS owner badges displayed in the Radix DLT wallet — a
                      Web3 native authentication system that replaces
                      traditional email logins, offering enhanced privacy,
                      security, and flexibility.
                    </p>
                  </div>
                </div>
                <div className="rpfs-container26">
                  <img
                    alt="image"
                    src="/Projects/rpfs%20icon.png"
                    className="rpfs-image33"
                  />
                </div>
              </div>
              <div className="rpfs-thq-pic-elm2">
                <div className="rpfs-thq-description-elm4">
                  <p className="rpfs-text28">
                    The navigation and main actions are straight forward and
                    familiar to web2 applications despite the web3 features. 
                  </p>
                </div>
                <img
                  alt="image"
                  src="/Projects/rpfs%20dapp%20dashboard.png"
                  className="rpfs-image34"
                />
                <img
                  alt="image"
                  src="/Projects/rpfs%20dapp%20folders.png"
                  className="rpfs-image35"
                />
              </div>
            </div>
          </div>
        </div>
        <Footer rootClassName="footerroot-class-name4"></Footer>
      </div>
    </div>
  )
}

export default RPFS
